import { render, staticRenderFns } from "./AllDistributor.vue?vue&type=template&id=f8535bba&scoped=true"
import script from "./AllDistributor.vue?vue&type=script&lang=js"
export * from "./AllDistributor.vue?vue&type=script&lang=js"
import style0 from "./AllDistributor.vue?vue&type=style&index=0&id=f8535bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8535bba",
  null
  
)

export default component.exports